const inputCharLength = inputElementId => {
	const inputElement = document.querySelector(`#${inputElementId}`);

	if (inputElement === null) {
		return false;
	}

	const currentValueLength = inputElement.value.length;
	const minlength = inputElement.getAttribute('minlength');
	const maxlength = inputElement.getAttribute('maxlength');

	if (currentValueLength > 0 &&
		minlength !== undefined &&
		maxlength !== undefined
	) {
		return (minlength <= currentValueLength && currentValueLength <= maxlength);
	}
};

export default inputCharLength;
